import { Page, Component } from "@bloomreach/spa-sdk";

export function usePromotionalTiles(page: Page, component: Component) {
  const { data, getSrcOf, getLinkOf } = useContentHelpers(page, component, {
    ref: component.getModels()?.PageRef,
  });

  return {
    promoTiles: [
      {
        image: getSrcOf(data?.promoTiles.imageOne),
        link: getLinkOf(data?.promoTiles.linkOne),
      },
      {
        image: getSrcOf(data?.promoTiles.imageTwo),
        link: getLinkOf(data?.promoTiles.linkTwo),
      },
      {
        image: getSrcOf(data?.promoTiles.imageThree),
        link: getLinkOf(data?.promoTiles.linkThree),
      },
    ],
  };
}
